import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  SALES_ORDER_LIST,
  SALES_ORDER_DATA,
  SALES_ORDER_SEARCH,
  SALES_ORDER_CREATE,
  SALES_ORDER_UPDATE,
  SALES_ORDER_VOID,
  SALES_ORDER_PDF,
  SALES_ORDER_EMAIL_AUTOMATED,
  SALES_ORDER_EMAIL_RESEND_AUTOMATED,
  SALES_ORDER_DAILY_BALANCE,
  SALES_ORDER_ITEM_SEARCH,
  SALES_ORDER_ITEM_LIST,
  SALES_ORDER_STATUS_LIST,
  SALES_ORDER_STATUS_DATA,
  SALES_ORDER_STATUS_CREATE,
  SALES_ORDER_STATUS_UPDATE,
  SALES_ORDER_STATUS_DELETE,
  SALES_ORDER_ACTIVITY_LOG_SEARCH,
  SALES_ORDER_CONVERT_TO_INVOICE,
  PRODUCT_STOCK_RESERVED_SEARCH,
  PRODUCT_STOCK_RESERVED_LIST,
} from "./actionType";

import {
  salesOrderListSuccess,
  salesOrderListFailure,
  salesOrderDataSuccess,
  salesOrderDataFailure,
  salesOrderSearchSuccess,
  salesOrderSearchFailure,
  salesOrderCreateSuccess,
  salesOrderCreateFailure,
  salesOrderUpdateSuccess,
  salesOrderUpdateFailure,
  salesOrderVoidSuccess,
  salesOrderVoidFailure,
  salesOrderPdfSuccess,
  salesOrderPdfFailure,
  salesOrderEmailAutomatedSuccess,
  salesOrderEmailAutomatedFailure,
  salesOrderEmailResendAutomatedSuccess,
  salesOrderEmailResendAutomatedFailure,
  salesOrderDailyBalanceSuccess,
  salesOrderDailyBalanceFailure,
  salesOrderItemSearchSuccess,
  salesOrderItemSearchFailure,
  salesOrderItemListSuccess,
  salesOrderItemListFailure,
  salesOrderStatusListSuccess,
  salesOrderStatusListFailure,
  salesOrderStatusDataSuccess,
  salesOrderStatusDataFailure,
  salesOrderStatusCreateSuccess,
  salesOrderStatusCreateFailure,
  salesOrderStatusUpdateSuccess,
  salesOrderStatusUpdateFailure,
  salesOrderStatusDeleteSuccess,
  salesOrderStatusDeleteFailure,
  salesOrderActivityLogSearchSuccess,
  salesOrderActivityLogSearchFailure,
  salesOrderConvertToInvoiceSuccess,
  salesOrderConvertToInvoiceFailure,
  productStockReservedSearchSuccess,
  productStockReservedSearchFailure,
  productStockReservedListSuccess,
  productStockReservedListFailure,
} from "./action";

import {
  salesOrderListApi,
  salesOrderDataApi,
  salesOrderSearchApi,
  salesOrderCreateApi,
  salesOrderUpdateApi,
  salesOrderVoidApi,
  salesOrderPdfApi,
  salesOrderEmailAutomatedApi,
  salesOrderEmailResendAutomatedApi,
  salesOrderDailyBalanceApi,
  salesOrderItemSearchApi,
  salesOrderItemListApi,
  salesOrderStatusListApi,
  salesOrderStatusDataApi,
  salesOrderStatusCreateApi,
  salesOrderStatusUpdateApi,
  salesOrderStatusDeleteApi,
  salesOrderActivityLogSearchApi,
  salesOrderConvertToInvoiceApi,
  productStockReservedSearchApi,
  productStockReservedListApi,
} from "../../helpers/fakebackend_helper";

//SALES_ORDER_LIST
function* salesOrderListSaga() {
  try {
    const response = yield call(salesOrderListApi);
    yield put(salesOrderListSuccess(response));
  } catch (error) {
    yield put(salesOrderListFailure(error));
  }
}

export function* watchSalesOrderList() {
  yield takeEvery(SALES_ORDER_LIST, salesOrderListSaga);
}

//SALES_ORDER_DATA
function* salesOrderDataSaga(action) {
  try {
    const response = yield call(salesOrderDataApi, action.payload);
    yield put(salesOrderDataSuccess(response));
  } catch (error) {
    yield put(salesOrderDataFailure(error));
  }
}

export function* watchSalesOrderData() {
  yield takeEvery(SALES_ORDER_DATA, salesOrderDataSaga);
}

//SALES_ORDER_SEARCH
function* salesOrderSearchSaga(action) {
  try {
    const response = yield call(salesOrderSearchApi, action.payload);
    yield put(salesOrderSearchSuccess(response));
  } catch (error) {
    yield put(salesOrderSearchFailure(error));
  }
}

export function* watchSalesOrderSearch() {
  yield takeEvery(SALES_ORDER_SEARCH, salesOrderSearchSaga);
}

//SALES_ORDER_CREATE
function* salesOrderCreateSaga(action) {
  try {
    const response = yield call(salesOrderCreateApi, action.payload);
    yield put(salesOrderCreateSuccess(response));
  } catch (error) {
    yield put(salesOrderCreateFailure(error));
  }
}

export function* watchSalesOrderCreate() {
  yield takeEvery(SALES_ORDER_CREATE, salesOrderCreateSaga);
}

//SALES_ORDER_UPDATE
function* salesOrderUpdateSaga(action) {
  try {
    const response = yield call(salesOrderUpdateApi, action.payload);
    yield put(salesOrderUpdateSuccess(response));
  } catch (error) {
    yield put(salesOrderUpdateFailure(error));
  }
}

export function* watchSalesOrderUpdate() {
  yield takeEvery(SALES_ORDER_UPDATE, salesOrderUpdateSaga);
}

//SALES_ORDER_VOID
function* salesOrderVoidSaga(action) {
  try {
    const response = yield call(salesOrderVoidApi, action.payload);
    yield put(salesOrderVoidSuccess(response));
  } catch (error) {
    yield put(salesOrderVoidFailure(error));
  }
}

export function* watchSalesOrderVoid() {
  yield takeEvery(SALES_ORDER_VOID, salesOrderVoidSaga);
}

//SALES_ORDER_PDF
function* salesOrderPdfSaga(action) {
  try {
    const response = yield call(salesOrderPdfApi, action.payload);
    yield put(salesOrderPdfSuccess(response));
  } catch (error) {
    yield put(salesOrderPdfFailure(error));
  }
}

export function* watchSalesOrderPdf() {
  yield takeEvery(SALES_ORDER_PDF, salesOrderPdfSaga);
}

//SALES_ORDER_EMAIL_AUTOMATED
function* salesOrderEmailAutomatedSaga(action) {
  try {
    const response = yield call(salesOrderEmailAutomatedApi, action.payload);
    yield put(salesOrderEmailAutomatedSuccess(response));
  } catch (error) {
    yield put(salesOrderEmailAutomatedFailure(error));
  }
}

export function* watchSalesOrderEmailAutomated() {
  yield takeEvery(SALES_ORDER_EMAIL_AUTOMATED, salesOrderEmailAutomatedSaga);
}

//SALES_ORDER_EMAIL_RESEND_AUTOMATED
function* salesOrderEmailResendAutomatedSaga(action) {
  try {
    const response = yield call(
      salesOrderEmailResendAutomatedApi,
      action.payload
    );
    yield put(salesOrderEmailResendAutomatedSuccess(response));
  } catch (error) {
    yield put(salesOrderEmailResendAutomatedFailure(error));
  }
}

export function* watchSalesOrderEmailResendAutomated() {
  yield takeEvery(
    SALES_ORDER_EMAIL_RESEND_AUTOMATED,
    salesOrderEmailResendAutomatedSaga
  );
}

//SALES_ORDER_DAILY_BALANCE
function* salesOrderDailyBalanceSaga(action) {
  try {
    const response = yield call(salesOrderDailyBalanceApi, action.payload);
    yield put(salesOrderDailyBalanceSuccess(response));
  } catch (error) {
    yield put(salesOrderDailyBalanceFailure(error));
  }
}

export function* watchSalesOrderDailyBalance() {
  yield takeEvery(SALES_ORDER_DAILY_BALANCE, salesOrderDailyBalanceSaga);
}

//SALES_ORDER_ITEM_SEARCH
function* salesOrderItemSearchSaga(action) {
  try {
    const response = yield call(salesOrderItemSearchApi, action.payload);
    yield put(salesOrderItemSearchSuccess(response));
  } catch (error) {
    yield put(salesOrderItemSearchFailure(error));
  }
}

export function* watchSalesOrderItemSearch() {
  yield takeEvery(SALES_ORDER_ITEM_SEARCH, salesOrderItemSearchSaga);
}

//SALES_ORDER_ITEM_LIST
function* salesOrderItemListSaga(action) {
  try {
    const response = yield call(salesOrderItemListApi, action.payload);
    yield put(salesOrderItemListSuccess(response));
  } catch (error) {
    yield put(salesOrderItemListFailure(error));
  }
}

export function* watchSalesOrderItemList() {
  yield takeEvery(SALES_ORDER_ITEM_LIST, salesOrderItemListSaga);
}

//SALES_ORDER_STATUS_LIST
function* salesOrderStatusListSaga(action) {
  try {
    const response = yield call(salesOrderStatusListApi, action.payload);
    yield put(salesOrderStatusListSuccess(response));
  } catch (error) {
    yield put(salesOrderStatusListFailure(error));
  }
}

export function* watchSalesOrderStatusList() {
  yield takeEvery(SALES_ORDER_STATUS_LIST, salesOrderStatusListSaga);
}

//SALES_ORDER_STATUS_DATA
function* salesOrderStatusDataSaga(action) {
  try {
    const response = yield call(salesOrderStatusDataApi, action.payload);
    yield put(salesOrderStatusDataSuccess(response));
  } catch (error) {
    yield put(salesOrderStatusDataFailure(error));
  }
}

export function* watchSalesOrderStatusData() {
  yield takeEvery(SALES_ORDER_STATUS_DATA, salesOrderStatusDataSaga);
}

//SALES_ORDER_STATUS_CREATE
function* salesOrderStatusCreateSaga(action) {
  try {
    const response = yield call(salesOrderStatusCreateApi, action.payload);
    yield put(salesOrderStatusCreateSuccess(response));
  } catch (error) {
    yield put(salesOrderStatusCreateFailure(error));
  }
}

export function* watchSalesOrderStatusCreate() {
  yield takeEvery(SALES_ORDER_STATUS_CREATE, salesOrderStatusCreateSaga);
}

//SALES_ORDER_STATUS_UPDATE
function* salesOrderStatusUpdateSaga(action) {
  try {
    const response = yield call(salesOrderStatusUpdateApi, action.payload);
    yield put(salesOrderStatusUpdateSuccess(response));
  } catch (error) {
    yield put(salesOrderStatusUpdateFailure(error));
  }
}

export function* watchSalesOrderStatusUpdate() {
  yield takeEvery(SALES_ORDER_STATUS_UPDATE, salesOrderStatusUpdateSaga);
}

//SALES_ORDER_STATUS_DELETE
function* salesOrderStatusDeleteSaga(action) {
  try {
    const response = yield call(salesOrderStatusDeleteApi, action.payload);
    yield put(salesOrderStatusDeleteSuccess(response));
  } catch (error) {
    yield put(salesOrderStatusDeleteFailure(error));
  }
}

export function* watchSalesOrderStatusDelete() {
  yield takeEvery(SALES_ORDER_STATUS_DELETE, salesOrderStatusDeleteSaga);
}

//SALES_ORDER_ACTIVITY_LOG_SEARCH
function* salesOrderActivityLogSearchSaga(action) {
  try {
    const response = yield call(salesOrderActivityLogSearchApi, action.payload);
    yield put(salesOrderActivityLogSearchSuccess(response));
  } catch (error) {
    yield put(salesOrderActivityLogSearchFailure(error));
  }
}

export function* watchSalesOrderActivityLogSearch() {
  yield takeEvery(
    SALES_ORDER_ACTIVITY_LOG_SEARCH,
    salesOrderActivityLogSearchSaga
  );
}

//SALES_ORDER_CONVERT_TO_INVOICE
function* salesOrderConvertToInvoiceSaga(action) {
  try {
    const response = yield call(salesOrderConvertToInvoiceApi, action.payload);
    yield put(salesOrderConvertToInvoiceSuccess(response));
  } catch (error) {
    yield put(salesOrderConvertToInvoiceFailure(error));
  }
}

export function* watchSalesOrderConvertToInvoice() {
  yield takeEvery(
    SALES_ORDER_CONVERT_TO_INVOICE,
    salesOrderConvertToInvoiceSaga
  );
}

//PRODUCT_STOCK_RESERVED_SEARCH
function* productStockReservedSearchSaga(action) {
  try {
    const response = yield call(productStockReservedSearchApi, action.payload);
    yield put(productStockReservedSearchSuccess(response));
  } catch (error) {
    yield put(productStockReservedSearchFailure(error));
  }
}

export function* watchProductStockReservedSearch() {
  yield takeEvery(
    PRODUCT_STOCK_RESERVED_SEARCH,
    productStockReservedSearchSaga
  );
}

//PRODUCT_STOCK_RESERVED_LIST
function* productStockReservedListSaga(action) {
  try {
    const response = yield call(productStockReservedListApi, action.payload);
    yield put(productStockReservedListSuccess(response));
  } catch (error) {
    yield put(productStockReservedListFailure(error));
  }
}

export function* watchProductStockReservedList() {
  yield takeEvery(PRODUCT_STOCK_RESERVED_LIST, productStockReservedListSaga);
}

export default function* SalesOrder() {
  yield all([
    fork(watchSalesOrderList),
    fork(watchSalesOrderData),
    fork(watchSalesOrderSearch),
    fork(watchSalesOrderCreate),
    fork(watchSalesOrderUpdate),
    fork(watchSalesOrderVoid),
    fork(watchSalesOrderPdf),
    fork(watchSalesOrderEmailAutomated),
    fork(watchSalesOrderEmailResendAutomated),
    fork(watchSalesOrderDailyBalance),
    fork(watchSalesOrderItemSearch),
    fork(watchSalesOrderItemList),
    fork(watchSalesOrderStatusList),
    fork(watchSalesOrderStatusData),
    fork(watchSalesOrderStatusCreate),
    fork(watchSalesOrderStatusUpdate),
    fork(watchSalesOrderStatusDelete),
    fork(watchSalesOrderActivityLogSearch),
    fork(watchSalesOrderConvertToInvoice),
    fork(watchProductStockReservedSearch),
    fork(watchProductStockReservedList),
  ]);
}
